interface PaginationProps {
  current: number;
  total: number;
  pageSize: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, pageSize, onChange }: PaginationProps) {
  const totalPages = Math.max(1, Math.ceil(total / pageSize));
  if (totalPages <= 1) return null;

  const pages: number[] = [];
  for (let i = 1; i <= totalPages; i += 1) pages.push(i);

  return (
    <nav className="flex items-center justify-center gap-2 mt-10" aria-label="分页导航">
      <button
        type="button"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
        className="h-10 px-4 rounded-md border border-background-300 text-sm text-foreground-700 flex items-center gap-1 transition-colors enabled:hover:border-primary-400 enabled:hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        <i className="ri-arrow-left-s-line"></i>
        上一页
      </button>
      <div className="flex items-center gap-1.5">
        {pages.map((p) => (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            className={`w-10 h-10 rounded-md text-sm transition-colors cursor-pointer ${
              p === current
                ? "bg-primary-500 text-background-50"
                : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ))}
      </div>
      <button
        type="button"
        disabled={current >= totalPages}
        onClick={() => onChange(current + 1)}
        className="h-10 px-4 rounded-md border border-background-300 text-sm text-foreground-700 flex items-center gap-1 transition-colors enabled:hover:border-primary-400 enabled:hover:text-primary-600 disabled:opacity-40 disabled:cursor-not-allowed cursor-pointer whitespace-nowrap"
      >
        下一页
        <i className="ri-arrow-right-s-line"></i>
      </button>
    </nav>
  );
}